// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Offer40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Offer40: FC<Offer40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M18.597 36.667a2.873 2.873 0 0 1-1.979-.806l-12.472-12.5a2.435 2.435 0 0 1-.618-.91 2.872 2.872 0 0 1-.202-1.041c0-.348.066-.695.196-1.042.131-.347.339-.66.624-.938l15.25-15.263a2.89 2.89 0 0 1 .906-.608c.348-.15.708-.226 1.08-.226h12.514c.764 0 1.418.272 1.962.816.544.544.816 1.198.816 1.962v12.486c0 .372-.075.727-.223 1.064-.148.337-.347.63-.597.88l-15.291 15.32c-.278.26-.588.459-.931.597a2.733 2.733 0 0 1-1.035.209Zm-.049-2.722 15.348-15.417V6.111h-12.5L6.076 21.445l12.473 12.5ZM29.59 12.667a2.19 2.19 0 0 0 1.604-.674 2.19 2.19 0 0 0 .674-1.604 2.19 2.19 0 0 0-.674-1.604 2.19 2.19 0 0 0-1.604-.674c-.62 0-1.155.225-1.604.674-.449.449-.673.984-.673 1.604 0 .62.224 1.155.673 1.604.45.45.984.674 1.604.674Z" />
        </svg>
    );
};

export default Offer40;
